import 'material-symbols';
import { CustomerAppShell } from '@apps/customer/components/AppShell';

function App(): JSX.Element {
  return <CustomerAppShell />;
}

export default App;
